import { Button } from "@chakra-ui/react";
import {
  customEvent,
  EventPathType,
  EventTriggerAndTargetType,
} from "goi_common";
import { baseColors } from "goi_common/src/design-system";
import { ReactNode } from "react";

function HeaderButton({
  path = "gnb",
  eventTrigger,
  onClick,
  children,
}: {
  path: keyof typeof EventPathType;
  eventTrigger: EventTriggerAndTargetType[EventPathType];
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <Button
      css={{
        padding: "6px 12px",
        backgroundColor: baseColors.red_100,
        color: baseColors.status_negative,
        borderRadius: "6px",
      }}
      onClick={() => {
        customEvent({
          newGtm: {
            path: "gnb",
            trigger_and_target: eventTrigger,
          },
        });
        onClick();
      }}
    >
      <span className="label_1_m">{children}</span>
    </Button>
  );
}

export default HeaderButton;
